// Конфигурация донных сливов

export const DRAIN_CONFIG = {
    modelPath: '/models/drains/drain.glb',

    // Конфигурация высоты (из drainHeightSettings.js)
    heights: {
        default: {
            baseDepth: 1.5,
            baseHeight: -0.31,
            depthCoefficientGreater: -0.1735,
            depthCoefficientLess: -0.15
        },
    },

    // Параметры модели (из drainModel.js)
    model: {
        scale: 1,
        heightCompensation: {
            base: 0.05,
            depthFactor: 0.02,
            // Дополнительное опускание модели при уменьшении масштаба.
            // Используется как множитель от величины уменьшения высоты модели.
            reducedScaleDropFactor: -0.38
        }
    },

    // Параметры позиционирования
    positioning: {
        baseMarginPercent: 0.25,
        minMarginPercent: 0.25,

        // Пороговые размеры для адаптивности
        thresholds: {
            widthBase: 3,
            lengthBase: 4
        }
    }
};
